export default "__VITE_ASSET__B$kI2_oz__"